export default "__VITE_ASSET__d06f1ae0__"